module.exports = "/dist/assets/images/arrow-down.svg";